import { render, staticRenderFns } from "./auction-results-program.vue?vue&type=template&id=b2870bd0&"
import script from "./auction-results-program.vue?vue&type=script&lang=js&"
export * from "./auction-results-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports